import { render } from "./OverlayFrame.vue?vue&type=template&id=a09a7ee6"
import script from "./OverlayFrame.vue?vue&type=script&lang=js"
export * from "./OverlayFrame.vue?vue&type=script&lang=js"

import exportComponent from "/Users/matthew/Documents/Vault/code/sal/subservience/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__